"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Surface = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const surface_styles_1 = require("@/components/common/surface/surface.styles");
let Surface = class Surface extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
Surface.styles = surface_styles_1.surfaceStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Surface.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Surface.prototype, "radius", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Surface.prototype, "density", void 0);
Surface = __decorate([
    (0, decorators_js_1.customElement)('mm-surface')
], Surface);
exports.Surface = Surface;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VyZmFjZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN1cmZhY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUEyRDtBQUUzRCwrRUFLbUQ7QUFHNUMsSUFBTSxPQUFPLEdBQWIsTUFBTSxPQUFRLFNBQVEsZ0JBQVU7SUFPckMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O0tBRVYsQ0FBQTtJQUNILENBQUM7O0FBVk0sY0FBTSxHQUFHLDhCQUFhLENBQUE7QUFFYztJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzt3Q0FBeUI7QUFDeEI7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7dUNBQXVCO0FBQ3RCO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO3dDQUF5QjtBQUx4RCxPQUFPO0lBRG5CLElBQUEsNkJBQWEsRUFBQyxZQUFZLENBQUM7R0FDZixPQUFPLENBWW5CO0FBWlksMEJBQU8ifQ==